/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Confirmed absence of a usable destination.
 */
export type MissingPropertySharingLink = {
    /**
     * Continue without a property link; never synthesize one.
     */
    status: MissingPropertySharingLink.status;
    /**
     * Stable explanation of the absence.
     */
    reason: MissingPropertySharingLink.reason;
    /**
     * Time at which the selection was evaluated.
     */
    resolvedAt: string;
};
export namespace MissingPropertySharingLink {
    /**
     * Continue without a property link; never synthesize one.
     */
    export enum status {
        NONE = 'none',
    }
    /**
     * Stable explanation of the absence.
     */
    export enum reason {
        NO_VALID_DESTINATION = 'no_valid_destination',
    }
}

